module.exports = __webpack_public_path__ + "img/emp-4.dd56ea89.jpeg";